import React from "react";
import SuspenseWrapper from "@/router/component/SuspenseWrapper";
const HelpDesk = React.lazy(() => import("@/pages/helpdesk/MyRequest"));
const MyTickets = React.lazy(() => import("@/pages/helpdesk/MyTickets"));
const Myteam = React.lazy(() => import("@/pages/helpdesk/team"));

const HelpDeskcomponent = [
    {
        path: "myRequests",
        element: (
            <SuspenseWrapper>
                <HelpDesk />
            </SuspenseWrapper>
        ),
    },
    {
        path: "myTickets",
        element: (
            <SuspenseWrapper>
                <MyTickets />
            </SuspenseWrapper>
        ),
    },
    {
        path: "helpDeskMyTeam",
        element: (
            <SuspenseWrapper>
                <Myteam />
            </SuspenseWrapper>
        ),
    }


];

export default HelpDeskcomponent;
